// extracted by mini-css-extract-plugin
module.exports = {"LogPage":"page_LogPage__3cqBw"};